import { get, put } from './api';

export const getUserNotifications = query => get('/users/notifications', query);
export const updateUserNotifications = (id, data) => put(`/notifications/${id}`, data);
